export type FeatureNodeId = string;

export interface FeatureNode {
  id: FeatureNodeId;
  label: string;
  children?: FeatureNode[];
}

// Seed data – you can expand/rename later or load this from config/JSON
export const featureTree: FeatureNode[] = [
  {
    id: "road",
    label: "Road",
    children: [
      {
        id: "road.linear",
        label: "Linear",
        children: [
          { id: "road.linear.edgeOfPavement", label: "Edge of Pavement" },
          { id: "road.linear.edgeOfShoulder", label: "Edge of Shoulder" },
          { id: "road.linear.centerLine", label: "Centerline" },
        ],
      },
      {
        id: "road.components",
        label: "Components",
        children: [
          { id: "road.components.pavement", label: "Pavement" },
          { id: "road.components.curb", label: "Curb" },
        ],
      },
    ],
  },

  {
    id: "bridge",
    label: "Bridge",
    children: [
      {
        id: "bridge.superstructure",
        label: "Superstructure",
        children: [
          { id: "bridge.superstructure.deck", label: "Deck" },
          { id: "bridge.superstructure.approach", label: "Approach" },
          { id: "bridge.superstructure.parapet", label: "Parapet" },
        ],
      },
      {
        id: "bridge.substructure",
        label: "Substructure",
        children: [
          { id: "bridge.substructure.abutment", label: "Abutment" },
          { id: "bridge.substructure.footing", label: "Footing" },
          { id: "bridge.substructure.girder", label: "Girder" },
        ],
      },
    ],
  },

  {
    id: "sewer",
    label: "Sewer / Drainage",
    children: [
      { id: "sewer.manhole", label: "Manholes" },
      { id: "sewer.inlet", label: "Inlets" },
      { id: "sewer.pipe", label: "Pipes" },
    ],
  },

  {
  id: "electric",
  label: "Electric",
  children: [
      {
        id: "electric.lighting",
        label: "Lighting",   // <- was "Light Poles"
        children: [
          {
            id: "util.node.elec.light.equipmentPadB",
            label: "Equipment Pad B",
          },
          {
            id: "util.node.elec.light.handholeDhvt",
            label: "HandHole-DHVT",
          },
          {
            id: "util.node.elec.light.handholeNdhvt",
            label: "HandHole-NDHVT",
          },
          {
            id: "util.node.elec.light.unitType9_40",
            label: "Light Unit Type 9-40",
          },
          {
            id: "util.node.elec.light.unitType9_49",
            label: "Light Unit Type 9-49",
          },
          {
            id: "util.node.elec.light.unitTypeSpec1",
            label: "Light Unit Type Spec1",
          },
          {
            id: "util.link.elec.light.nonMetallicConduit",
            label: "Non-Metallic Conduit (Lighting)",
          },
        ],
      },
      {
        id: "electric.signal",
        label: "Signal",
        children: [
          {
            id: "util.node.elec.signal.handholeNdhvt",
            label: "Handhole-NDHVT",
          },
          {
            id: "util.node.elec.signal.pedPushButton",
            label: "Ped Push Button",
          },
          {
            id: "util.node.elec.signal.equipmentPad",
            label: "Signal Equipment Pad",
          },
          {
            id: "util.node.elec.signal.pa100A40",
            label: "Signal PA100-A-40",
          },
          {
            id: "util.node.elec.signal.serviceCabinet",
            label: "Signal Service Cabinet",
          },
          {
            id: "util.link.elec.signal.nonMetallicConduit",
            label: "Non-Metallic Conduit (Signal)",
          },
        ],
      },
    ],
  },
];

